import { useQuery } from '@tanstack/react-query';
import { apiFetch } from './apiClient';
import { queryKeys } from './queryKeys';

/** Shape of the public GET /status endpoint (server/src/routes/system.ts).
 *  `orchestrator` is null when ORCHESTRATOR_URL is unset (not configured),
 *  true/false when configured and reachable/unreachable. */
export interface SystemStatus {
  api: boolean;
  database: boolean;
  orchestrator: boolean | null;
}

/** Polls the real health endpoint so the shell status dot reflects actual
 *  system state instead of a hardcoded green. Public route — no auth needed. */
export function useSystemStatus() {
  return useQuery<SystemStatus>({
    queryKey: queryKeys.status,
    queryFn: () => apiFetch<SystemStatus>('/status'),
    refetchInterval: 30_000,
    staleTime: 15_000,
  });
}
